import { IApplicationContext } from '../../../types/applicationContext';
import {
  fetchPublicOfferBusinessEntityAccept,
  IPublicOfferBusinessEntityAcceptRequest,
  type TPublicOfferBusinessEntityAcceptResponse,
} from '../../../repositories/dailyrent/v1/public-offer/business-entity/accept';
import { ResponseError } from '../../../utils/errors/responseError';
import { IErrorDetails } from '@cian/peperrors';

interface IError extends IErrorDetails {
  key?: string;
  message?: string;
  code?: string;
}

export interface IResponseError {
  domain: string;
  message: string;
  details?: IError;
}

export const acceptBusinessEntityPublicOffer = async (
  context: IApplicationContext,
  parameters: IPublicOfferBusinessEntityAcceptRequest,
) => {
  const { httpApi, logger } = context;

  try {
    const { statusCode, response } = (await fetchPublicOfferBusinessEntityAccept({
      httpApi,
      parameters,
    })) as TPublicOfferBusinessEntityAcceptResponse;

    if (statusCode === 200) {
      return { success: true };
    }

    throw new ResponseError({
      message: 'Ошибка при подписании оферты',
      domain: '/v1/public-offer/business-entity/accept/',
      details: response.errors?.[0] as IError,
    } as IResponseError);
  } catch (error) {
    logger.error(error);

    throw error;
  }
};
